export const version = 'v2.2.4-1711-g1547b464'
